export default "__VITE_ASSET__B7k6xJFT__"